import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgScissors = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 5.952a2.452 2.452 0 1 1 4.904 0 2.452 2.452 0 0 1-4.904 0M5.952 2a3.952 3.952 0 0 0-1.087 7.752L8.764 12l-3.899 2.247A3.954 3.954 0 0 0 5.952 22a3.952 3.952 0 0 0 1.596-7.568l2.717-1.566 10.61 6.116a.75.75 0 1 0 .75-1.3L11.767 12l9.858-5.683a.75.75 0 1 0-.75-1.3l-10.61 6.117-2.717-1.566A3.953 3.953 0 0 0 5.952 2M3.5 18.048a2.452 2.452 0 1 1 4.904 0 2.452 2.452 0 0 1-4.904 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgScissors;
